import { Component, inject } from '@angular/core';
import { NetworkStatusService } from '@app/services';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Full-screen offline page. Renders only while the network is down (driven by
 * NetworkStatusService) and self-dismisses the moment the connection returns.
 * Mounted once at the app root.
 */
@Component({
  selector: 'app-offline',
  imports: [TranslatePipe],
  templateUrl: './offline.html',
  styleUrl: './offline.css',
})
export class Offline {
  network = inject(NetworkStatusService);
}
